export default "__VITE_ASSET__LLOUsVGP__"